interface IconCloseBigOptions {
    cssClasses? : string
}

export function IconCloseBig(props : IconCloseBigOptions) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={props?.cssClasses}>
            <path d="M1 1.00983L15.2503 15.2601" stroke="black" stroke-width="1.38986" stroke-linecap="round"/>
            <path d="M15.252 1L1.00167 15.2503" stroke="black" stroke-width="1.38986" stroke-linecap="round"/>
        </svg>
    );
}
